/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    ul: "ul",
    li: "li",
    a: "a",
    strong: "strong"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h3, null, "Projects"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "Public Art - Art Walk, December, 2020 arranged by Old Town Business Association and The Art League"), "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "https://www.bokbokbooks.co.uk/authors-and-illustrators-rifat-s-taher/"
  }, "Illustrator"), " for children's poetry anthology '", React.createElement(_components.a, {
    href: "https://www.bokbokbooks.co.uk/product/floating-words/"
  }, React.createElement(_components.strong, null, "Floating Words")), "/", React.createElement(_components.a, {
    href: "https://www.bokbokbooks.co.uk/product/%e0%a6%9c%e0%a6%b2%e0%a7%87%e0%a6%ad%e0%a6%be%e0%a6%b8%e0%a6%be-%e0%a6%b6%e0%a6%ac%e0%a7%8d%e0%a6%a6%e0%a6%ae%e0%a6%be%e0%a6%b2%e0%a6%be/"
  }, React.createElement(_components.strong, null, "জলেভাসা শব্দমালা")), "' in collaborating with ", React.createElement(_components.a, {
    href: "https://www.bokbokbooks.co.uk"
  }, React.createElement(_components.strong, null, "BokBok Books")), " and Arts Council England"), "\n"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
